import extract from 'flarum/common/utils/extract';
import tagLabel from './tagLabel';
import sortTags from '../utils/sortTags';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';

export default function tagsLabel(tags, attrs = {}) {
  const children = [];
  const { link, ...otherAttrs } = attrs;
  otherAttrs.className = classList('', otherAttrs.className);

  if (tags) {
    sortTags(tags).filter((tag) =>  
    {
      if (app.session.user) {
        return tag.pkgId() == app.data.pkgLogo.id && !tag.isNotBasic() && ((app.session.user.isAdmin() && (tag.isAdminLook() || !tag.isHidden())) || (!app.session.user.isAdmin() && !tag.isHidden()));
      } else {
        return tag.pkgId() == app.data.pkgLogo.id && !tag.isNotBasic() && !tag.isHidden();
      }
    }).forEach((tag) => {
      // console.log('tag-->', tag);
      
      if (tag || tags.length === 1) {
        children.push(tagLabel(tag, { link }));
      }
    });
  } else {
    children.push(tagLabel());
  }

  return <span {...otherAttrs}>{children}</span>;
}
